import ReactMarkdown from 'react-markdown';

function expandBacklinks(value: string) {
  return value.replace(/\[\[([a-z0-9-]+)\]\]/gi, '[$1](/projects/$1/overview)');
}

export function Markdown({ children }: { children: string }) {
  return (
    <div className="markdown">
      <ReactMarkdown
        components={{
          a: ({ href, children: content }) => <a href={href} rel={href?.startsWith('http') ? 'noreferrer' : undefined} target={href?.startsWith('http') ? '_blank' : undefined}>{content}</a>,
        }}
      >
        {expandBacklinks(children)}
      </ReactMarkdown>
    </div>
  );
}
